import * as React from "react";
import styled from "styled-components";

import { TableBody, TableCell, TableRow, TestWrapper } from "@ui/Atoms";
import { InfoMessage } from "@ui/Molecules";

interface Props {
  message: string;
  location?: string;
  testId?: string;
}

export const NoResultsNotification = React.forwardRef((props: Props, ref) => (
  <TableBody key={`no-cleanings-${props.location}`} ref={ref}>
    <TableRow>
      {props.location && <TableCell>{props.location}</TableCell>}
      <TableCell
        colSpan={props.location ? 6 : 7}
        style={{ display: "table-cell", textAlign: "center" }}
      >
        <TestWrapper testId={props.testId}>
          <NoContent>
            <InfoMessage message={props.message} />
          </NoContent>
        </TestWrapper>
      </TableCell>
    </TableRow>
  </TableBody>
));

NoResultsNotification.displayName = "NoResultsNotification";

const NoContent = styled.div`
  margin: ${props => props.theme.margins.base_x6}
    ${props => props.theme.margins.base_x2}
    ${props => props.theme.margins.base_x2};
  display: flex;
  justify-content: center;
`;
